import React from 'react'

const NotFound = () => {
    return (
        <div style={{ height: '100vh' }} className="d-flex align-center justify-center w-100 h-100">
            <h1 className="font-large text-center">404<br />PAGE</h1>
        </div>
    )
}

export default NotFound
